import { render, staticRenderFns } from "./ImportObserveList.vue?vue&type=template&id=583836bd&"
import script from "./ImportObserveList.vue?vue&type=script&lang=js&"
export * from "./ImportObserveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports